module.exports = __webpack_public_path__ + "static/media/notification-insight.e3796edb.mp3";